import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Input from '../elements/Input';
import Button from '../../components/elements/Button';
import emailjs from 'emailjs-com';
import validator from 'validator';

import Alert from '@material-ui/lab/Alert';

const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool,
};

const defaultProps = {
  ...SectionProps.defaults,
  split: false,
};

const Cta = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  split,
  ...props
}) => {
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [success, setSuccess] = useState(false);
  // form validation state
  const [nameError, setNameError] = useState();
  const [emailError, setEmailError] = useState();
  const [messageError, setMessageError] = useState();

  const outerClasses = classNames(
    'cta section center-content-mobile reveal-from-bottom',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'cta-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
    split && 'cta-split'
  );

  const validateFields = () => {
    // validate fields
    let error = false;
    if (email.length === 0) {
      setEmailError('Email cannot be blank.');
      error = true;
    }
    if (!validator.isEmail(email)) {
      setEmailError('Please enter a valid email address.');
      error = true;
    }
    if (name.length === 0) {
      setNameError('Name cannot be blank.');
      error = true;
    }
    if (message.length === 0) {
      setMessageError('Message cannot be blank.');
      error = true;
    }
    if (error) return false;
    return true;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (validateFields()) {
      const body = { message, email, name };
      emailjs
        .send(
          'service_tr16cgo',
          'template_w6j44zb',
          body,
          'user_Bd6yXIkBfJI0yCYPLhVLY'
        )
        .then(
          function (response) {
            console.log('SUCCESS!', response.status, response.text);
            setSuccess(true);
          },
          function (error) {
            console.log('FAILED...', error);
          }
        );
    }
  };

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <div className='cta-slogan'>
            <h3 className='m-0'>Contact us for inquiries!</h3>
            <h4>For direct contact, email pytf@gopyt.com</h4>
          </div>
          <div className='cta-action'>
            <Input
              type='email'
              label='Your Information'
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailError && (
              <div style={{ color: 'red', fontSize: '12px' }}>{emailError}</div>
            )}
            <Input
              type='text'
              placeholder='Name'
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {nameError && (
              <div style={{ color: 'red', fontSize: '12px' }}>{nameError}</div>
            )}
            <Input
              type='textarea'
              placeholder='Message'
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            {messageError && (
              <div style={{ color: 'red', fontSize: '12px' }}>
                {messageError}
              </div>
            )}
            <Button onClick={sendEmail}>Submit</Button>
          </div>
        </div>
        {success && <Alert severity='success'>Thank you for your input!</Alert>}
      </div>
    </section>
  );
};

Cta.propTypes = propTypes;
Cta.defaultProps = defaultProps;

export default Cta;
